// Import internal
import { Common } from './common.model';
import { Acl } from './authorization.model';

export enum Level {
    ADMIN = 'ADMIN',
    EDIT = 'EDIT',
    READ = 'READ'
}

export class Role extends Common {
    declare public id: string;
    public acl: Acl[];
    public description: string;
    public app?: string;
}

export const rolesMapping: Partial<Role>[] = [
    {
        id: 'billing', description: `Le rôle 'billing'  ne donne aucun accès au portail,
    il permet de configurer automatiquement l'utilisateur comme destinataire des communications liées à la facturation sur le projet.` },
    {
        id: 'comm-only', description: `le rôle 'comm-only'  ne donne aucun accès au portail,
    il donne uniquement la possibilité de configurer des préférences de communication pour l'utilisateur.` },
    {
        id: 'ops', description: `Le rôle 'ops' donne accès au portail pour consulter les données les projets,
    créer et consulter les incidents, créer et consulter les requests. Il permet de configurer des préférences de communication.`},
    {
        id: 'project-admin', description: `Le rôle 'project-admin' donne accès au portail pour consulter les données des projets,
    créer et consulter les incidents, créer et consulter les requests.
    Il permet de configurer des préférences de communication et de créer des utilisateurs.`}
];
